export default __webpack_public_path__ + "static/media/IconDesc_Fabric.256.e3c4dc27.png";